module.exports = __webpack_public_path__ + "static/sc-cale-6ce4229c6f03fe9a1f72b4b216a6b11a.png";